/* Copyright (c) 2018 Scaper */

import * as React from "react";
import { IPlace } from "../../functions/src/api/placeInterface";
import { Logger } from "../utils/logger";

import Map = google.maps.Map;
import Marker = google.maps.Marker;

import "./placeMap.scss";

interface IProps {
    place: IPlace | "LOADING" | undefined;
}

export class PlaceMap extends React.PureComponent<IProps, {}> {
    private static readonly DEFAULT_ZOOM = 9;
    private static readonly NEW_BRUNSWICK_POSITION = { lat: 40.4883559, lng: -74.5110078 };

    private _map: Map | undefined;
    private get map(): Map {
        if (this._map == null) {
            this._map = new google.maps.Map(this.mapRef.current, {
                center: PlaceMap.NEW_BRUNSWICK_POSITION,
                zoom: PlaceMap.DEFAULT_ZOOM,
            });
        }
        return this._map;
    };

    private _marker: Marker | undefined;
    private get marker(): Marker {
        if (this._marker == null) {
            this._marker = new google.maps.Marker({
                map: this.map,
                position: PlaceMap.NEW_BRUNSWICK_POSITION,
                visible: false,
            });
        }
        return this._marker;
    }

    private readonly mapRef = React.createRef<HTMLDivElement>();

    public render() {
        return <div className="scpr-PlaceMap" ref={this.mapRef} />;
    }

    public componentDidMount() {
        this.updateMap();
    }

    public componentDidUpdate(prevProps: IProps) {
        const { place } = this.props;
        const { place: prevPlace } = prevProps;
        if (place !== prevPlace) {
            this.updateMap();
        }
    }

    private updateMap() {
        const { place } = this.props;

        this.marker.setVisible(false);

        if (place == null) {
            this.map.setCenter(PlaceMap.NEW_BRUNSWICK_POSITION);
            this.map.setZoom(PlaceMap.DEFAULT_ZOOM);
            return;
        }

        if (place === "LOADING") {
            return;
        }

        const { geometry } = place;
        if (geometry == null) {
            Logger.error("Unable to determine place geometry.");
            return;
        }

        const { location, viewport } = geometry;
        if (viewport != null) {
            this.map.fitBounds(viewport);
        } else {
            this.map.setCenter(location);
            this.map.setZoom(17);
        }

        this.marker.setPosition(location);
        this.marker.setVisible(true);
    }
}
